<ng-template #surfaceContent>
  <div class="menu-surface">
    <ng-content></ng-content>
  </div>
</ng-template>
